/*
 * Invoices "Download CSV": invoice numbers, amounts and statuses; never the teacher's email, PAN or
 * GSTIN. Pure; csv.test.js.
 */
import { csv_file_name } from '../../../util_components/csv_export/to_csv';
import { bare } from '../payouts/csv';

export const invoices_csv_name = (table, pay_month) => () =>
  csv_file_name({ page: 'Invoices', table, period: pay_month });

// list_view rows: the money as numbers, rates as the server's percent strings.
export const INVOICE_COLUMNS = [
  { header: 'Invoice number', value: (r) => bare(r.invoice_number) },
  { header: 'Invoice ID', key: 'invoice_uuid' },
  { header: 'Teacher', value: (r) => bare(r.teacher_name) },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Close version', value: (r) => r.raw.close_version_no, kind: 'number' },
  { header: 'Status', value: (r) => bare(r.status && r.status.label) },
  { header: 'Taxable', value: (r) => r.raw.taxable, kind: 'money' },
  { header: 'GST rate %', value: (r) => r.raw.gst_rate_pct, kind: 'number' },
  { header: 'GST', value: (r) => r.raw.gst, kind: 'money' },
  { header: 'Invoice total', value: (r) => r.raw.invoice_total, kind: 'money' },
  { header: 'TDS rate %', value: (r) => r.raw.tds_rate_pct, kind: 'number' },
  { header: 'TDS', value: (r) => r.raw.tds, kind: 'money' },
  { header: 'We pay', value: (r) => r.raw.payable, kind: 'money' },
  { header: 'Confirmed at (IST)', value: (r) => bare(r.confirmed_at), kind: 'datetime' },
  { header: 'Replaced at (IST)', value: (r) => bare(r.superseded_at), kind: 'datetime' }
];

// awaiting_view rows ("Needs review" months have no payable figure yet).
export const AWAITING_COLUMNS = [
  { header: 'Teacher', value: (r) => bare(r.teacher_name) },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Payable', value: (r) => (r.needs_review ? null : r.payable_raw), kind: 'money' },
  { header: 'Needs review', key: 'needs_review', kind: 'bool' },
  { header: 'Reminders sent', value: (r) => bare(r.reminders_sent), kind: 'number' },
  {
    header: 'Last reminder (IST)',
    value: (r) => (r.last_reminder === 'None yet' ? '' : bare(r.last_reminder)),
    kind: 'datetime'
  },
  {
    header: 'Status',
    value: (r) => (r.reopened ? 'Reopened' : 'Not confirmed yet')
  }
];

/*
 * The awaiting list filters each overview page client-side, so a page can come back empty while the
 * server still has more; collect_all_pages would stop there. Skip ahead to a non-empty page.
 */
export const skip_empty_pages =
  (read, max_skips = 1000) =>
  async (cursor) => {
    let page = (await read(cursor)) || {};
    for (let i = 0; i < max_skips; i += 1) {
      const more = page.next !== null && page.next !== undefined && page.next !== '';
      if ((page.rows || []).length || !more) return page;
      // eslint-disable-next-line no-await-in-loop -- offset pages are sequential
      page = (await read(page.next)) || {};
    }
    return page;
  };
